import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "../../../principal/customFetchBase";

export const certificadoXMLApi = createApi({
  reducerPath: "certificadoXMLApi",
  baseQuery: customFetchBase,
  tagTypes: ["CertificadoXML"],
  endpoints: () => ({}),
});
